import { observer } from 'mobx-react';
import React from 'react';
import { useUDData } from '@udemy/ud-data';
import { useMobileNavStore } from '../../hooks/use-mobile-nav-store';
import { MobileLearnAINav } from '../../mobile/mobile-nav/level-one/mobile-learn-ai-nav.react-component';
import { MobileStudentProfileNav } from '../../mobile/mobile-nav/level-one/mobile-student-profile-nav.react-component';
import { MobileCustomCategoryNav } from './level-one/mobile-custom-category-nav.react-component';
import { MobileLearningPathFolderNav } from './level-one/mobile-learning-path-folder-nav.react-component';
import { MobileSubcategoryNav } from './level-one/mobile-subcategory-nav.react-component';
import { ManageSubNavs } from './manage-sub-navs.react-component';
export const SubNavs = observer(() => {
  var _mobileNavStore$navig;
  const mobileNavStore = useMobileNavStore();
  const udConfig = useUDData().Config;
  const hasL1 = mobileNavStore.isLevelLoaded(1);
  const isLPEnabled = udConfig.features.organization.learning_path.enabled;
  return /*#__PURE__*/React.createElement(React.Fragment, null, hasL1 && /*#__PURE__*/React.createElement(MobileLearnAINav, null), hasL1 && ((_mobileNavStore$navig = mobileNavStore.navigationCategories) === null || _mobileNavStore$navig === void 0 ? void 0 : _mobileNavStore$navig.map(category => {
    var _category$children;
    return /*#__PURE__*/React.createElement(MobileSubcategoryNav, {
      key: category.id,
      parentCategory: category,
      subcategories: (_category$children = category.children) !== null && _category$children !== void 0 ? _category$children : []
    });
  })), hasL1 && /*#__PURE__*/React.createElement(MobileCustomCategoryNav, null), hasL1 && isLPEnabled && /*#__PURE__*/React.createElement(MobileLearningPathFolderNav, null), /*#__PURE__*/React.createElement(ManageSubNavs, null), hasL1 && /*#__PURE__*/React.createElement(MobileStudentProfileNav, null));
});
//# sourceMappingURL=sub-navs.react-component.js.map